import { SxProps, Theme } from '@mui/material/styles';

export const garageDetailStyles = {
    sectionHeader: {
        px: 3,
        py: 2,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        bgcolor: 'grey.50',
        borderBottom: '1px solid',
        borderColor: 'divider',
    } satisfies SxProps<Theme>,
    infoRow: {
        px: 3,
        py: 2.5,
        display: 'grid',
        gridTemplateColumns: '160px 1fr',
        gap: 2,
        alignItems: 'center',
    } satisfies SxProps<Theme>,
    loading: {
        display: 'flex',
        justifyContent: 'center',
        mt: 8,
    } satisfies SxProps<Theme>,
    root: {
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
    } satisfies SxProps<Theme>,
    borderedPaper: {
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        overflow: 'hidden',
    } satisfies SxProps<Theme>,
    contactValue: {
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
    } satisfies SxProps<Theme>,
    tabs: {
        borderBottom: '1px solid',
        borderColor: 'divider',
    } satisfies SxProps<Theme>,
    tab: {
        textTransform: 'none',
        minHeight: 52,
    } satisfies SxProps<Theme>,
    emptyState: {
        px: 3,
        py: 4,
        textAlign: 'center',
    } satisfies SxProps<Theme>,
    vehicleLinkRow: {
        px: 3,
        py: 2,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        textDecoration: 'none',
        color: 'inherit',
        '&:hover': {
            bgcolor: 'action.hover',
        },
    } satisfies SxProps<Theme>,
    vehicleRowMain: {
        display: 'flex',
        gap: 2,
        alignItems: 'center',
    } satisfies SxProps<Theme>,
    vehicleIcon: {
        width: 36,
        height: 36,
        borderRadius: '50%',
        bgcolor: 'primary.50',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    } satisfies SxProps<Theme>,
    vehicleRowAside: {
        display: 'flex',
        gap: 1,
        alignItems: 'center',
    } satisfies SxProps<Theme>,
    serviceRow: {
        px: 3,
        py: 2,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    } satisfies SxProps<Theme>,
    serviceRowMain: {
        display: 'flex',
        gap: 2,
        alignItems: 'center',
    } satisfies SxProps<Theme>,
    serviceRowAside: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
    } satisfies SxProps<Theme>,
    serviceDate: {
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
    } satisfies SxProps<Theme>,
    serviceMachineLink: {
        fontSize: 12,
        color: 'primary.main',
        textDecoration: 'none',
        fontWeight: 500,
    } satisfies SxProps<Theme>,
};
